import { render, staticRenderFns } from "./ProjectMessageList.vue?vue&type=template&id=cf3a3934&"
import script from "./ProjectMessageList.vue?vue&type=script&lang=ts&"
export * from "./ProjectMessageList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports